import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: 'fa-icon[color]'
})
export class FaIconColorDirective {
  @Input() set color(color: string) {
    this.el.nativeElement.classList.add(`mat-${color}`);
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  constructor(private el: ElementRef) {}
}
